<template>
  <div class="map-cat-row cat-block-margin">
      <category-scores
        :catIndex="catIndex"
        :riskData="riskData">
      </category-scores>
      <subcategory-row v-for="(subcategory, index) in category.subcategories" 
        :key="subcategory.name | makeID"
        :catIndex="catIndex"
        :subcatIndex="index"
        :riskData="riskData"
        :subcategory="category.subcategories[index]">
      </subcategory-row>
  </div>
</template>

<script>
import CategoryScoresRow from './CategoryScoresRow';
import MapSubcatRow from './MapSubcatRow';

export default {
  name: 'map-category-row',
  props: [
    'category',
    'riskData',
    'catIndex',
  ],
  components: {
    'category-scores': CategoryScoresRow,
    'subcategory-row': MapSubcatRow,
  },
};
</script>

<style>
  .map-cat-row {
    flex: 1 0 100%;
  }
</style>



// WEBPACK FOOTER //
// MapCategoryRow.vue?1eac0d40